
export type _DeductionComponent = 'employee' | 'employer';

export interface IDeductionComponent {
    id: number,
    type: _DeductionComponent,    

    code: string,
    name: string,
    description: string,

    category: string,
    amountExpression: string,

    isActive: boolean,

  }



  
  export const defaultDeductionComponent : IDeductionComponent = {
    id: 0,
    type: 'employee',  

    code: '',
    name: '',
    description: '',

    category: '',
    amountExpression: '',

    isActive: true,    
  }

  

  export interface IDeductionComponentSearch {
 
    name: string,
    description: string
  }